@use "ui/styles/breakpoints";
@use "ui/styles/colorsOld";
@use "ui/styles/fontsOld";
@use "ui/oldStyles/grid";
@use "ui/oldStyles/theme";

.wrapper {
  min-height: 80px;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  top: 0;
  z-index: 1;
  background-color: theme.fetch(theme.$light, "colors", "background");

  @media only screen and (max-width: grid.$grid-mobile-breakpoint) {
    border-bottom: 1px solid theme.fetch(theme.$light, "colors", "dividers");
    width: 100%;
    padding-left: 12px;
    padding-right: 12px;
    min-height: 48px;
  }
}

.hidden {
  min-height: 80px;

  @media only screen and (max-width: grid.$grid-mobile-breakpoint) {
    min-height: 48px;
  }
}

.menu {
  height: 30px;
  width: 30px;
  display: none;

  &.open {
    background-image: url("/static/svg/menu-close-light.svg");
  }

  &.closed {
    background-image: url("/static/svg/menu-open-light.svg");
  }

  @media only screen and (max-width: grid.$grid-mobile-breakpoint) {
    display: inline;
    margin-left: -40px;

    &.homepage {
      margin-top: 10px;
      margin-right: 10px;
      align-self: start;
    }
  }
}

.items {
  width: 420px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media only screen and (max-width: grid.$grid-mobile-breakpoint) {
    display: none;
  }

  &.user {
    width: 390px;
  }
}

.user {
  justify-content: flex-end;

  a {
    margin-left: 24px;
  }
}

.mobile {
  background-color: theme.fetch(theme.$light, "colors", "foreground");
  display: none;

  @media only screen and (max-width: grid.$grid-mobile-breakpoint) {
    &.open {
      display: block;
      z-index: 2;
      position: absolute;
      top: 60px;
      left: 12px;
      right: 12px;
      border-radius: 4px;
      box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.36);

      &.homepage {
        top: 52px;
      }

      a {
        width: 85%;
        display: block;
        margin: 20px auto;
        text-align: center;
      }
    }
  }
}

.logo {
  margin-left: 6px;
  color: theme.fetch(theme.$light, "colors", "primary");
}

.link {
  font-size: fontsOld.$small;
  font-weight: fontsOld.$book-weight;
  text-decoration: none;
  transition: all 0.3s;

  color: theme.fetch(theme.$light, "colors", "links", "text");

  &.current {
    color: theme.fetch(theme.$light, "colors", "buttons", "primary", "background");

    &:hover {
      color: theme.fetch(theme.$light, "colors", "buttons", "primary", "hover");
    }
  }

  &:active {
    color: theme.fetch(theme.$light, "colors", "links", "active");
  }

  &:hover,
  &:active {
    color: theme.fetch(theme.$light, "colors", "links", "focus");
  }

  &:focus {
    color: theme.fetch(theme.$light, "colors", "links", "focus");
  }

  &:hover {
    color: theme.fetch(theme.$light, "colors", "links", "hover");
  }

  &.primary {
    font-weight: fontsOld.$medium-weight;
    font-size: fontsOld.$smallX1;
    text-align: center;
    border-radius: 4px;
    align-items: center;
    padding: 9px 12px;

    color: theme.fetch(theme.$light, "colors", "buttons", "primary", "text");
    background-color: theme.fetch(theme.$light, "colors", "buttons", "primary", "background");

    &:hover {
      background-color: theme.fetch(theme.$light, "colors", "buttons", "primary", "hover");
    }

    &:active {
      background-color: theme.fetch(theme.$light, "colors", "buttons", "primary", "active");
    }

    &:hover,
    &:active {
      background-color: theme.fetch(theme.$light, "colors", "buttons", "primary", "focus");
    }

    &:focus {
      background-color: theme.fetch(theme.$light, "colors", "buttons", "primary", "focus");
    }
  }
}
